export * from './cargo-group-my-suffix.service';
export * from './cargo-group-my-suffix-update.component';
export * from './cargo-group-my-suffix-delete-dialog.component';
export * from './cargo-group-my-suffix-detail.component';
export * from './cargo-group-my-suffix.component';
export * from './cargo-group-my-suffix.route';
